import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import { BirthdayType } from '../../../app/types';
import { setNodeData } from '../../../features/mainSlice';
import Dropdown from '../../shared/Dropdown';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      marginBottom: 12,
    },
  },
  {
    name: 'Birthday',
  },
);

const Birthday = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode } = useSelector(state => state.ma);
  const { triggerCondition } = selectedNode?.data;

  const typeItem = Object.values(BirthdayType).map(type => ({
    text: t(`birthday.${type}`),
    value: type,
  }));

  const onChange = value => {
    dispatch(setNodeData({ triggerCondition: value }));
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('condition-setting.clickType')}</div>
      <Dropdown
        menuItems={typeItem}
        value={triggerCondition}
        onChange={onChange}
      />
    </div>
  );
};

export default Birthday;
